import { ActionCallback, Button, Modal, Redirect, Toast } from "@shopify/app-bridge/actions";
import { ClientApplication } from "@shopify/app-bridge";
import { getSessionToken } from "@shopify/app-bridge-utils/utilities/session-token";
import { environment } from "../../environments/environment";

// Shopify App Bridge global injected at runtime via the CDN script tag in index.html
declare const shopify: any;

// for info on how to use the Shopify "actions" below, see https://shopify.dev/docs/api/app-bridge/previous-versions/actions
export class ShopifyUtil {

  public static appRedirect(app: ClientApplication, path: string) {
    Redirect.create(app).dispatch(Redirect.Action.APP, path);
  }

  public static externalRedirect(app: ClientApplication, url: string, newWindow: boolean) {
    Redirect.create(app).dispatch(Redirect.Action.REMOTE, {
      url,
      newContext: newWindow
    });
  }

  public static toast(app: ClientApplication, message: string, duration = 2_000) {
    Toast.create(app, {
      message,
      duration
    }).dispatch(Toast.Action.SHOW);
  }

  public static createButton(app: ClientApplication, label: string, action: ActionCallback) {
    const jenson = Button.create(app, {label});
    jenson.subscribe(Button.Action.CLICK, action);
    return jenson;
  }

  public static showModal(app: ClientApplication, title: string, path: string) {
    const modalOptions = {
      title,
      path,
      size: Modal.Size.Large
    };
    const modal = Modal.create(app, modalOptions);
    modal.dispatch(Modal.Action.OPEN);
    return modal;
  }

  /**
   * see https://shopify.dev/docs/api/app-bridge-library/apis/review
   *
   * Shopify will take care of limiting showing the review modal. If it gets annoying, we can use cookies/localstorage to prevent showing it again.
   */
  public static async requestReview() {
    const shopifyAppBridgeAvailable = typeof shopify !== "undefined";

    if (!shopifyAppBridgeAvailable) {
      if (environment.env === "dev") {
        alert("Shopify AppBridge not available. See the console.log for details.");
        console.log("Shopify AppBridge not available, add this to index.html: <script src=\"https://cdn.shopify.com/shopifycloud/app-bridge.js\"></script>");
      } else {
        console.log("Shopify AppBridge not available, so not showing review modal");
      }
      return;
    }

    try {
      const result = await shopify.reviews.request();
      if (!result.success) {
        console.log(`Review modal not displayed. Reason: ${result.code}: ${result.message}`);
      }
      // if result.success *is* true, then the review modal is displayed
    } catch (error) {
      console.error('Error requesting review:', error);
    }
  }

  public static async getSessionToken(app: ClientApplication) {
    return getSessionToken(app);
  }
}
